/**
 * 旅平險說明 Modal 條件
 */
export enum Limit {
  /** 國內一人 */
  NTDO = 'INSUREHOW_NTDO',
  /** 國外一人 */
  NTAO = 'INSUREHOW_NTAO',
  /** 申根一人 */
  NTAGO = 'INSUREHOW_NTAGO',
  /** 國內多人 */
  NTDM = 'INSUREHOW_NTDM',
  /** 國外多人 */
  NTAM = 'INSUREHOW_NTAM',
  /** 申根多人 */
  NTAGM = 'INSUREHOW_NTAGM'
}
